import { gsap, ScrollTrigger } from 'gsap/all'
gsap.registerPlugin(ScrollTrigger)

export function positionsFade(element: HTMLElement) {
  const cards = [...Array.from(element.querySelectorAll('.js-card'))] as HTMLElement[]

  let mm = gsap.matchMedia()

  mm.add('(min-width: 769px)', () => {
    gsap.set(cards, { yPercent: 25, opacity: 0 })

    cards.forEach((card, index) => {
      gsap.to(card, {
        yPercent: 0,
        opacity: 1,
        ease: 'expo.out',
        duration: 1.2,
        scrollTrigger: {
          trigger: card,
          start: 'top 80%',
          end: 'bottom 80%',
          scrub: 1,
          invalidateOnRefresh: true,
          once: true
          // markers: true
        }
      })
    })
  })
}
